import { useEffect, useState } from "react";
import { useApi } from "../../utils/Api";
import CompaniesView from "../../components/digital-licenses/CompaniesView";
import Translate from "../../utils/Translate";
import { IconButton, useMediaQuery, useTheme } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";

export default function MyData(props) {
  const [companies, setCompanies] = useState([]);
  const api = useApi();

  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up("lg"));

  useEffect(() => {
    async function loadMyData() {
      const response = await api.fetch(
        `${process.env.REACT_APP_MAIN_URL}mydata`,
        false,
        "GET"
      );
      if (response.isSuccessful) {
        setCompanies(response.companies);
      }
    }

    loadMyData();
  }, [api]);
  {
    /* <li key={company.orgNo}>
              {company.name}, {company.orgNo}
            </li> */
  }
  return (
    <div className="dlWrapper" style={{ position: "relative" }}>
      {/* <div className="dlHeader">{Translate.get("MyData")}</div> */}
      <div
        style={
          isLargeScreen
            ? { position: "absolute", left: 0, top: 0 }
            : { width: "100%" }
        }
      >
        <IconButton onClick={() => window.history.back()}>
          <ArrowBack />
        </IconButton>
      </div>

      {companies &&
        companies.map((company, index) => (
          <CompaniesView key={index} company={company} />
        ))}
    </div>
  );
}
